/**
 * URL parameter constants for the application
 * These constants should be used consistently across the application
 * to maintain a standardized URL structure
 */

// Copilot message page parameters
export const URL_PARAM_CONVERSATION_ID = "conversationId";
export const URL_PARAM_RESPONSE_ID = "responseId";
